import { atom } from 'recoil';

export const verifyModal = atom<boolean>({
  key: 'verifyModal',
  default: false,
});
